/*=========================================================================================
  File Name: moduleDataList.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleTeamIntegrationState.js'
import mutations from './moduleTeamIntegrationMutations.js'
import actions from './moduleTeamIntegrationActions.js'
import getters from './moduleTeamIntegrationGetters.js'

export default {
  // isRegistered: false,
  // namespaced: true,
  state,
  mutations,
  actions,
  getters
}

